import { gql } from 'urql';

const FetchRDCAccounts = gql`
  query FetchRDCAccounts {
    myAccounts {
      __typename
      forRdc {
        __typename
        id
        nickname
        accountNumberLast4
        product
        ... on IDisplayBalance {
          displayBalance {
            title
            amount {
              amount
              currency
              formatted
            }
          }
        }
      }
    }
  }
`;

export default FetchRDCAccounts;
